import { defineStore } from "pinia";
import { computed, ref } from "vue";
import {useApiClient} from "@/hooks/api-hook.ts";
import {Charter} from "@/api/client/models/index.ts";
import {
  GetFinancialDataRequestBuilderGetQueryParameters
} from "@/api/client/charter/getFinancialData/index.ts";

export const useCharterFinancialDataStore = defineStore("charterFinancialData", () => {
  const api = useApiClient();

  // State
  const financialData = ref<Charter[]>([]);
  const loading = ref(false);
  const error = ref<string | null>(null);

  // Getters
  const financialDataCount = computed(() => financialData.value.length);
  const hasFinancialData = computed(() => financialData.value.length > 0);
  const isLoading = computed(() => loading.value);
  const hasError = computed(() => error.value !== null);

  // Actions
  async function fetchFinancialData(params: GetFinancialDataRequestBuilderGetQueryParameters) {
    loading.value = true;
    error.value = null;

    try {
      financialData.value = await api.charter.getFinancialData.get({queryParameters: params})
    } catch (err) {
      error.value = err instanceof Error ? err.message : "Failed to fetch financial data";
      console.error("Error fetching financial data:", err);
    } finally {
      loading.value = false;
    }
  }

  function clearFinancialData() {
    financialData.value = [];
    error.value = null;
  }

  function clearError() {
    error.value = null;
  }

  return {
    // State
    financialData,
    loading,
    error,

    // Getters
    financialDataCount,
    hasFinancialData,
    isLoading,
    hasError,

    // Actions
    fetchFinancialData,
    clearFinancialData,
    clearError,
  };
});
